export const SERVICES = [
  {
    id: "structural",
    title: "Structural Painting",
    desc: "Large-scale industrial structure painting engineered for durability, corrosion protection and aesthetic appeal across plants and towers.",
    icon: "Building2",
    bg: "/services/structural.png",
  },
  {
    id: "building",
    title: "Building Painting",
    desc: "Residential and commercial property painting delivered with precision, premium finishes and long-lasting protection.",
    icon: "Home",
    bg: "/services/building.jpeg",
  },
  {
    id: "writing",
    title: "Painting & Writing Work",
    desc: "Detailed painting and industrial signage / writing services ensuring clarity, compliance and brand consistency.",
    icon: "PenTool",
    bg: "/services/writing.png",
  },
  {
    id: "vehicle",
    title: "Vehicle Painting Advertisement",
    desc: "Expert vehicle painting and advertisement advisement for optimum appearance, visibility and longevity on the move.",
    icon: "Truck",
    bg: "/services/vehicle.webp",
  },
  {
    id: "heat",
    title: "Heat Resistance Painting",
    desc: "High-temperature resistant coatings that protect surfaces in extreme industrial environments and extend asset life.",
    icon: "Flame",
    bg: "/services/heat.png",
  },
  {
    id: "epoxy",
    title: "Epoxy Coating & Marble Texture",
    desc: "Professional epoxy floor coatings and decorative marble texture painting for a sleek, durable, and premium finish.",
    icon: "Layers",
    bg: "/services/epoxy.webp",
  },
  {
    id: "polishing",
    title: "Polishing Work",
    desc: "High-quality polishing services to maintain, restore and enhance the beauty of painted and finished surfaces.",
    icon: "Sparkles",
    bg: "/services/polishing.webp",
  },
  {
    id: "thermoplastic",
    title: "Thermoplastic Road Marking",
    desc: "High-quality thermoplastic road marking paint works that maintain and enhance road surface visibility and durability.",
    icon: "SignpostBig",
    bg: "/services/thermoplastic.webp",
  },
];

export const CLIENTS = [
  "Wonder Cement Limited",
  "UltraTech Cement Limited",
  "NUVOCO Cement Limited",
  "JK Cement Limited",
  "Shree Cement Limited",
  "The India Cement Limited",
  "Binani Cement Limited",
  "Jindal Shah Limited",
];

export const CLIENT_LOCATIONS = [
  { name: "Wonder Cement Limited", site: "& All Grinding Units", logo: "/clients/wonder.png" },
  { name: "UltraTech Cement Limited", site: "Banswara, Chhattisgarh", logo: "/clients/ultratech.webp" },
  { name: "NUVOCO Cement Limited", site: "Multiple Units", logo: "/clients/nuvoco.png" },
  { name: "JK Cement Limited", site: "Nimbahera, Mangrol, Jharli, Muddapur", logo: "/clients/jkcement.jpeg" },
  { name: "Shree Cement Limited", site: "Ras, Jobner, Etah, Suratgarh, Lakshar", logo: "/clients/shree.png" },
  { name: "The India Cement Limited", site: "Multiple Units", logo: null },
  { name: "Binani Cement Limited", site: "Multiple Units", logo: null },
  { name: "Jindal Saw Limited", site: "Total Pipe Solutions", logo: "/clients/jindal.jpeg" },
];

const g = (folder, file) => `/gallery/${folder}/${file}`;

export const GALLERY = {
  structure: ["/gallery/structure/pu1.jpg", "/gallery/structure/eq1.jpg", "/gallery/structure/scaff1.jpg", "/services/structural.png", ...[2, 3, 4, 5, 10, 11, 12, 13, 14, 16, 19, 20, 22, 26, 29, 33].map((n) => g("structure", `s${n}.jpg`))],
  building: ["/services/building.jpeg", ...[4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 26].map((n) => g("building", `b${n}.jpg`))],
  vehicle: ["/services/vehicle.webp", ...[5, 10, 11, 12, 13, 17, 19, 21, 35, 36, 37, 38, 39, 40].map((n) => g("vehicle", `v${n}.jpg`))],
  writing: ["/services/writing.png", ...[18, 19, 20, 21].map((n) => g("building", `b${n}.jpg`))],
  heat: ["/gallery/heat/heat1.jpg", "/services/heat.png"],
  epoxy: ["/services/epoxy.webp"],
  thermoplastic: ["/services/thermoplastic.webp"],
};

export const FAQS = [
  {
    q: "What painting services does Pooja Painting Work offer?",
    a: "We offer structural painting, building painting, painting & writing work, vehicle painting advertisement, heat-resistance painting, epoxy coating & marble texture painting, polishing work, and thermoplastic road marking — all under one roof, for industrial and commercial clients across India.",
  },
  {
    q: "How many years of experience does Pooja Painting Work have?",
    a: "We bring 12+ years of hands-on industrial painting experience, having delivered large-scale projects for India's leading cement and infrastructure firms since 2013.",
  },
  {
    q: "Which major companies has Pooja Painting Work worked with?",
    a: "We have served Wonder Cement, UltraTech Cement, NUVOCO Cement, JK Cement, Shree Cement, The India Cement, Binani Cement and Jindal Saw — across multiple plants and grinding units.",
  },
  {
    q: "Do you handle large industrial and cement plant painting projects?",
    a: "Yes. We specialise in large-scale structural and industrial painting, including heat-resistant coatings and epoxy floor systems engineered for the demanding conditions of cement plants and heavy industry.",
  },
  {
    q: "How do I request a quote or estimate?",
    a: "Simply fill out the Request a Quote form on this website, or call us at +91 9887396976, +91 7891005554 or +91 7231066569. Our team will respond with a tailored quotation for your project.",
  },
];

export const COMPANY = {
  name: "Pooja Painting Work",
  tagline: "Painting Excellence, Redefined.",
  phones: ["+91 9887396976", "+91 7891005554", "+91 7231066569"],
  emails: ["poojapainting45@gmail.com", "contact@poojapainting.com"],
  website: "poojapainting.com",
  gstin: "08AQQPA4110R1ZK",
  address: "Bapu Nagar, Panchwati, Senthi, Chittorgarh, Rajasthan",
  experience: 12,
};
